<template>
<div class="h-screen flex overflow-hidden bg-cool-gray-100">
    <div class="">
      <div class="relative h-full max-w-screen-xl mx-auto">

      </div>
    </div>
  
    <div class="relative  pb-12 sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32 m-auto">


  
      <main class=" mx-auto max-w-screen-xl px-4   sm:px-6    ">
        <div class="text-center items-center">
            <img src="../assets/ccme-logo.png" class="w-48  mb-10 m-auto"  />
            <!-- <img  src="../../ccme-logo.png" class="w-64  m-auto"  /> -->
          <h2 class="text-4xl tracking-tight leading-10 font-bold  text-primary-900 sm:text-4xl sm:leading-none md:text-4xl">
            <br class="xl:hidden">
            <span class="">اللجنة المركزية</span>
          </h2>
          <p class="mt-2 max-w-md font-light mx-auto text-base text-primary-900 sm:text-xl md:mt-3">
            لأنتخابات المجالس البلدية
          </p>
          <div class="mt-4 w-full mx-auto sm:flex sm:justify-center md:mt-8">
            <div class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
            <router-link to="/signup" class="w-full flex items-center justify-center px-12 py-5 border border-transparent text-xl  leading-6 font-bold rounded-md text-primary-800  bg-white hover:bg-red-50 hover:text-primary-800 focus:outline-none focus:border-primary-300 focus:shadow-outline-yellow transition duration-150  ease-in-out md:py-4 md:text-2xl md:px-10">
               تـسجـيل كـنـاخـب
             </router-link>
            </div>
          </div>
            <div class="mt-2 w-full mx-auto sm:flex sm:justify-center md:mt-3">
            <div class="mt-2 rounded-md shadow sm:mt-0 sm:ml-3">
            <router-link to="/enquiry" class="w-full flex items-center justify-center px-8 py-5 border border-transparent text-base leading-6 font-bold rounded-md text-blue-50  bg-primary-500 hover:text-primary-50 focus:outline-none focus:border-primary-300 focus:shadow-outline-yellow transition duration-150 ease-in-out md:py-4 md:text-base md:px-10">
              الاستعلام عن تسجيلك كناخب
             </router-link>
            </div>
          </div>
          <div class="text-medium underline mt-5">
            <a href="/edit">
            تعديل بيانات التسجيل </a>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "Home",
};
</script>

<style scoped>


@keyframes ckw {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
